module.exports = __webpack_public_path__ + "static/media/broken-egg.7d6c07f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/broken-egg.svg
// module id = 589
// module chunks = 11